<style>
    .center-img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 60px;
    }
</style>

<div class="loading">
    <div class="cpanel" style="padding: 40px 60px;">
        <div class="cpanel-content">

            <div class="col-md-12 text-center">
                <h1 class="c-success bold">Thank You!</h1>
            </div>

            <div class="col-md-12 text-center">
                <h4 class="bold fc16">Your enquiry has been submitted successfully!</h4>
            </div>

            <div class="col-md-12 text-center">
                <span class="bold c-deep-orange">Please wait, we are redirecting you to client dashboard...</span>
            </div>

            <div class="col-md-12 text-center">
                <img src="assets/images/loading.gif" alt="" class="center-img" />
            </div>

        </div>
    </div>
</div>